import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";   // or HashRouter
import App from "./App.jsx";


createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter /* basename="/" */>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);